// @flow

import ko from 'rgs-knockout';

import {
	identityDocumentTypeChecksExtend,
	documentTypeInputMaskExtend,
} from 'ko-extender-identity-document-type';

import type { Observable } from 'rgs-knockout';
import type { KnownRestIdentityDocTypeEnum as DocTypeEnum } from 'known-rest-identity-docs';
import type {
	IDocumentTypeChecksExtend,
	IDocumentTypeInputmaskExtend,
} from 'ko-extender-identity-document-type';

export type IObservableDocumentType = Observable<DocTypeEnum>
	& IDocumentTypeInputmaskExtend
	& IDocumentTypeChecksExtend;

export function observableDocumentType (value: DocTypeEnum): IObservableDocumentType {
	return ko.observable(value)
		.extend(identityDocumentTypeChecksExtend)
		.extend(documentTypeInputMaskExtend);
}
